function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import utils from './utils';
import { Switch } from './components/components';
var Danmaku = function () {
    function Danmaku(options, player) {
        var _this = this;
        _classCallCheck(this, Danmaku);
        _defineProperty(this, 'checkShield', function (dan) {
            var type = typeof dan.type !== 'string' ? utils.number2Type(dan.type) : dan.type;
            var origin = dan.origin;
            if ((_this[''.concat(type, 'Limit')] || _this[''.concat(origin, 'Limit')]) && !/(\/n)|(\\n)/i.test(dan.text)) {
                return false;
            }
            return true;
        });
        this.options = options;
        this.player = player;
        this.createHash = utils.initHash();
        this.tunnelPadding = 6;
        this.container = this.options.container;
        this.danTunnel = {
            right: {},
            left: {},
            top: {},
            bottom: {}
        };
        this.tunnelHeights = {
            right: [],
            left: [],
            top: [],
            bottom: []
        };
        this.danCount = {
            unknown: 0,
            mfuns: 0,
            bili: 0,
            acfun: 0
        };
        this.danData = {
            unknown: null,
            mfuns: null,
            bili: null,
            acfun: null
        };
        this.danIndex = 0;
        this.dan = [];
        this.showing = this.options.isShow;
        this._opacity = this.options.opacity;
        this._fontScale = this.options.fontScale;
        this._speed = this.options.speed;
        this._limitArea = this.options.limitArea;
        this.events = this.options.events;
        this.topLimit = false;
        this.bottomLimit = false;
        this.leftLimit = false;
        this.rightLimit = false;
        this.colorLimit = false;
        this.advanceLimit = false;
        this.mfunsLimit = false;
        this.biliLimit = false;
        this.acfunLimit = false;
        this.unknownLimit = false;
        this.originFilter = new Set();
        this.unlimited = this.options.unlimited;
        this.loaded = false;
        this.paused = true;
        this.danmakuCheck = false;
        this.danmakuTip = this.player.template.danmakuTip;
        this.danmakuTipBox = this.player.template.danmakuTipBox;
        this.currentX = 0;
        this.currentY = 0;
        this.danmakuCatch = this.options.danmakuCatch;
        this._measure('');
        this.load();
        this.initDanmakuTips();
    }
    _createClass(Danmaku, [
        {
            key: 'initDanmakuTips',
            value: function initDanmakuTips() {
                var _this2 = this;
                var danmakuTipMaskMove = function danmakuTipMaskMove(e) {
                    var _ref;
                    if ((_ref = Math.sqrt(Math.pow(e.pageX - _this2.currentX, 2) + Math.pow(e.pageY - _this2.currentY, 2)) > _this2.player.options.danmaku.sensitivity) !== null && _ref !== void 0 ? _ref : 3.5) {
                        _this2.currentX = e.pageX;
                        _this2.currentY = e.pageY;
                        return;
                    }
                    _this2.currentX = e.pageX;
                    _this2.currentY = e.pageY;
                    var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
                    var scrollY = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                    var items = _this2.container.getElementsByClassName('mfunsPlayer-danmaku-item');
                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];
                        var boundingClientRect = item.getBoundingClientRect();
                        var danLeft = boundingClientRect.left + scrollX;
                        var danRight = boundingClientRect.right + scrollX;
                        var danTop = boundingClientRect.top + scrollY;
                        var danBottom = boundingClientRect.bottom + scrollY;
                        if (danLeft < e.pageX && e.pageX < danRight && danTop < e.pageY && e.pageY < danBottom) {
                            _this2.currentLockDanmaku = item;
                            _this2.lockDanmakuData = _this2.getDanmakuData(item.dataset.id);
                            if (_this2.player.options.uid === +_this2.lockDanmakuData.author) {
                                _this2.player.template.danmakuCancel.classList.add('show');
                                _this2.player.template.danmakuReport.classList.remove('show');
                            } else {
                                _this2.player.template.danmakuCancel.classList.remove('show');
                                _this2.player.template.danmakuReport.classList.add('show');
                            }
                            item.classList.add('lock');
                            _this2.danmakuTip.classList.add('show');
                            var itemTop = danTop - _this2.container.getBoundingClientRect().top - scrollY;
                            _this2.danmakuTip.style.top = itemTop + 5 + 'px';
                            _this2.danmakuTip.style.height = 45 + item.offsetHeight + 'px';
                            if (e.pageX - _this2.container.getBoundingClientRect().left < 75) {
                                _this2.danmakuTip.style.left = -scrollX;
                            } else if (_this2.container.clientWidth - (e.pageX - _this2.container.getBoundingClientRect().left) < 75) {
                                _this2.danmakuTip.style.left = 'auto';
                                _this2.danmakuTip.style.right = -scrollX;
                            } else {
                                _this2.danmakuTip.style.left = e.pageX - _this2.container.getBoundingClientRect().left - 75 - scrollX + 'px';
                            }
                            break;
                        } else {
                            item.classList.remove('lock');
                        }
                    }
                };
                this.danmakuTip.addEventListener('mouseover', function () {
                    _this2.player.template.danmakuTipMask.removeEventListener('mousemove', danmakuTipMaskMove);
                });
                this.danmakuTip.addEventListener('mouseleave', function () {
                    _this2.danmakuTip.classList.remove('show');
                    _this2.currentLockDanmaku && _this2.currentLockDanmaku.classList.remove('lock');
                    _this2.player.template.danmakuTipMask.addEventListener('mousemove', danmakuTipMaskMove);
                });
                this.player.template.danmakuTipMask.addEventListener('mousemove', danmakuTipMaskMove);
                this.player.template.danmakuTipBox.addEventListener('click', function (e) {
                    e.stopPropagation();
                });
                this.player.template.danmakuPraise.addEventListener('click', function (e) {
                });
                this.player.template.danmakuCopy.addEventListener('click', function (e) {
                    navigator && navigator.clipboard && navigator.clipboard.writeText(_this2.lockDanmakuData.text).then(function (res) {
                        _this2.player.notice('已复制');
                        _this2.danmakuTip.classList.remove('show');
                    })['catch'](function (err) {
                        console.log(err);
                    });
                });
                this.player.template.danmakuCancel.addEventListener('click', function (e) {
                });
                var reportIReason;
                this.player.template.danmakuReport.addEventListener('click', function (e) {
                    setTimeout(function () {
                        _this2.currentLockDanmaku && _this2.currentLockDanmaku.classList.add('lock');
                    }, 50);
                    _this2.player.template.danmakuReportMask.classList.add('show');
                    _this2.player.template.danmakuReportContent.innerHTML = _this2.lockDanmakuData.text;
                    _this2.player.template.danmakuReportMask.addEventListener('click', function (e) {
                        e.stopPropagation();
                    });
                    _this2.player.template.danmakuReportModelClose.addEventListener('click', function (e) {
                        _this2.currentLockDanmaku && _this2.currentLockDanmaku.classList.remove('lock');
                        _this2.player.template.danmakuReportMask.classList.remove('show');
                        _this2.player.template.danmakuReportDetail.classList.remove('show');
                    });
                    var allReports = _this2.player.template.danmakuReportMask.querySelectorAll('.mfunsPlayer-switch');
                    allReports.forEach(function (el, index) {
                        if (!_this2['reportOption'.concat(index)]) {
                            _this2['reportOption'.concat(index)] = new Switch(el, false, {
                                on: function on() {
                                    for (var i = 0; i < allReports.length; i++) {
                                        i !== index && _this2['reportOption'.concat(i)].off(1);
                                    }
                                    if (el.children[1].innerHTML !== '其他') {
                                        reportIReason = el.children[1].innerHTML;
                                        _this2.player.template.danmakuReportDetail.classList.remove('show');
                                        _this2.player.template.danmakuReportSubmit.classList.remove('disable');
                                    } else {
                                        reportIReason = '';
                                        _this2.player.template.danmakuReportDetail.classList.add('show');
                                        _this2.player.template.danmakuReportDetail.value = '';
                                    }
                                },
                                off: function off(optionTrigger) {
                                    if (_this2.player.template.danmakuReportDetail.classList.contains('show'))
                                        _this2.player.template.danmakuReportDetail.classList.remove('show');
                                    if (!_this2.player.template.danmakuReportSubmit.classList.contains('disable') && !optionTrigger)
                                        _this2.player.template.danmakuReportSubmit.classList.add('disable');
                                }
                            });
                        } else {
                            _this2['reportOption'.concat(index)].off();
                        }
                    });
                    _this2.player.template.danmakuReportDetail.addEventListener('input', function (e) {
                        _this2.player.template.danmakuReportSubmit.classList[e.target.value.trim() ? 'remove' : 'add']('disable');
                    });
                });
                this.player.template.danmakuReportSubmit.addEventListener('click', function () {
                    if (_this2.player.template.danmakuReportSubmit.classList.contains('disable'))
                        return;
                    var _this2$lockDanmakuDat = _this2.lockDanmakuData, author = _this2$lockDanmakuDat.author, text = _this2$lockDanmakuDat.text, origin = _this2$lockDanmakuDat.origin;
                    var id = _this2.options.api.id;
                    console.log(_this2.lockDanmakuData);
                    var reportData = {
                        danId: id !== null && id !== void 0 ? id : null,
                        author: author !== null && author !== void 0 ? author : null,
                        text: text,
                        reason: reportIReason || _this2.player.template.danmakuReportDetail.value
                    };
                    if (origin === 'mfuns')
                        _this2.player.events.trigger('danmaku_report', reportData);
                    else
                        _this2.player.notice('不能跨站执法哦~');
                    _this2.currentLockDanmaku && _this2.currentLockDanmaku.classList.remove('lock');
                    _this2.player.template.danmakuReportMask.classList.remove('show');
                    _this2.player.template.danmakuReportDetail.classList.remove('show');
                });
            }
        },
        {
            key: 'load',
            value: function load() {
                var _this3 = this;
                var _JSON$parse = JSON.parse(JSON.stringify(this.options.api)), address = _JSON$parse.address, danmakuAddition = _JSON$parse.danmakuAddition, id = _JSON$parse.id, otherDanParams = _JSON$parse.otherDanParams, advDanApi = _JSON$parse.advDanApi;
                var apiurl = ''.concat(address, '?id=').concat(id).concat(otherDanParams);
                this.endpoints = danmakuAddition || [];
                var advDanData = [];
                id && address && this.endpoints.push({
                    url: apiurl,
                    type: 'dplayer-danmaku',
                    origin: 'mfuns'
                });
                advDanApi && this.endpoints.push({
                    url: ''.concat(advDanApi.address, '/v1/advdanmaku?id=').concat(advDanApi.id),
                    type: 'mfuns-advDanmaku-oldApi'
                });
                this.events && this.events.trigger('danmaku_load_start', this.endpoints);
                this.player.template.danmakuSource.classList.add('loading');
                this.loaded = false;
                this.endpoints.forEach(function (el) {
                    if (!el.origin) {
                        switch (el.type) {
                        case 'bili-danmaku':
                            el.origin = 'bili';
                            break;
                        case 'acfun-danmaku':
                            el.origin = 'acfun';
                            break;
                        default:
                            el.origin = 'unknown';
                        }
                    }
                });
                this._readAllEndpoints(this.endpoints, function (results, loadStatus) {
                    _this3.player.template.danmakuSource.classList.remove('loading');
                    if (!loadStatus) {
                        console.log(loadStatus, results);
                        _this3.events && _this3.events.trigger('danmaku_load_end', []);
                        return _this3.options.error(results);
                    } else {
                        console.log(results);
                        _this3.dan = [].concat.apply([], results).sort(function (a, b) {
                            return a.time - b.time;
                        });
                        _this3.dan.forEach(function (d) {
                            d.id = _this3.createHash(8);
                            if (d.type == 8) {
                                advDanData.push(d.text);
                            }
                            _this3.danCount[d.origin]++;
                        });
                        console.log(_this3.danCount);
                        _this3.events && _this3.events.trigger('danmaku_load_end', _this3.dan);
                        _this3.loaded = true;
                        window.requestAnimationFrame(function () {
                            _this3.frame();
                        });
                        _this3.options.callback(_this3.dan.length, advDanData);
                    }
                });
            }
        },
        {
            key: 'reload',
            value: function reload(newId, newAdvDanApi, newAddition, newOtherDanParams) {
                var _this4 = this;
                this.player.template.danmakuCount.innerHTML = '弹幕装填中...';
                if (newId) {
                    this.options.api.id = newId;
                }
                if (newOtherDanParams) {
                    this.options.api.otherDanParams = newOtherDanParams;
                }
                if (newAddition) {
                    this.options.api.danmakuAddition = newAddition;
                }
                if (newAdvDanApi) {
                    this.options.api.advDanApi = newAdvDanApi;
                }
                [
                    'mfuns',
                    'bili',
                    'acfun',
                    'unknown'
                ].forEach(function (el) {
                    var currentOrigin = _this4.player.template['danmakuSource_'.concat(el)];
                    var originCount = currentOrigin.querySelector('.mfunsPlayer-video-danmaku-source-item-count');
                    currentOrigin.classList.replace('success', 'nodata');
                    currentOrigin.classList.replace('error', 'nodata');
                    originCount.innerHTML = '-';
                });
                this.dan = [];
                this.danCount = {
                    unknown: 0,
                    mfuns: 0,
                    bili: 0,
                    acfun: 0
                };
                this.danData = {
                    unknown: null,
                    mfuns: null,
                    bili: null,
                    acfun: null
                };
                this.clear();
                this.load();
            }
        },
        {
            key: 'reloadEndPoints',
            value: function reloadEndPoints(origin) {
                var _this5 = this;
                var currentEndPoints = [];
                this.player.template.danmakuCount.innerHTML = '弹幕装填中...';
                this.endpoints.forEach(function (el) {
                    if (el.origin === origin) {
                        currentEndPoints.push(el);
                    }
                });
                console.log(currentEndPoints);
                this.events && this.events.trigger('danmaku_load_start', this.endpoints);
                this._readAllEndpoints(currentEndPoints, function (results, loadStatus) {
                    if (!loadStatus) {
                        console.log(loadStatus, results);
                        _this5.events && _this5.events.trigger('danmaku_load_end', []);
                        _this5.options.error(results, true);
                    } else {
                        console.log(_this5.danData);
                        var _this5$danData = _this5.danData, acfun = _this5$danData.acfun, bili = _this5$danData.bili, mfuns = _this5$danData.mfuns, unknown = _this5$danData.unknown;
                        _this5.dan = [].concat(_toConsumableArray(acfun !== null && acfun !== void 0 ? acfun : []), _toConsumableArray(bili !== null && bili !== void 0 ? bili : []), _toConsumableArray(mfuns !== null && mfuns !== void 0 ? mfuns : []), _toConsumableArray(unknown !== null && unknown !== void 0 ? unknown : [])).sort(function (a, b) {
                            return a.time - b.time;
                        });
                        _this5.dan.forEach(function (d) {
                            d.id = _this5.createHash(8);
                            if (d.type == 8) {
                                advDanData.push(d.text);
                            }
                            _this5.danCount[d.origin]++;
                        });
                        _this5.events && _this5.events.trigger('danmaku_load_end', _this5.dan);
                        _this5.loaded = true;
                        _this5.options.callback(_this5.dan.length, null, true);
                    }
                });
            }
        },
        {
            key: '_readAllEndpoints',
            value: function _readAllEndpoints(endpoints, callback) {
                var _this6 = this;
                var allRequests = endpoints.map(function (link) {
                    return new Promise(function (resolve, reject) {
                        _this6.options.apiBackend.read({
                            url: link.url,
                            type: link.type,
                            origin: link.origin,
                            success: function success(data) {
                                _this6.danData[''.concat(link.origin)] = data;
                                var currentOrigin = _this6.player.template['danmakuSource_'.concat(link.origin)];
                                var originCount = currentOrigin.querySelector('.mfunsPlayer-video-danmaku-source-item-count');
                                var originOperate = currentOrigin.querySelector('.mfunsPlayer-video-danmaku-source-item-operate');
                                currentOrigin.classList.replace('nodata', 'success');
                                currentOrigin.classList.replace('error', 'success');
                                originCount.innerHTML = data.length;
                                originOperate.onclick = function () {
                                    if (currentOrigin.classList.contains('forbidden')) {
                                        currentOrigin.classList.replace('forbidden', 'success');
                                        console.log(currentOrigin.classList);
                                        _this6[''.concat(link.origin, 'Limit')] = false;
                                        _this6.originFilter['delete'](link.origin);
                                        _this6.events && _this6.events.trigger('danmaku_filter', {
                                            key: 'origin',
                                            value: _toConsumableArray(_this6.originFilter)
                                        });
                                    } else {
                                        currentOrigin.classList.replace('success', 'forbidden');
                                        console.log(currentOrigin.classList);
                                        _this6[''.concat(link.origin, 'Limit')] = true;
                                        var items = _this6.container.querySelectorAll('.mfunsPlayer-danmaku-item');
                                        items.forEach(function (el) {
                                            if (el.dataset.origin === link.origin) {
                                                el.innerHTML = '';
                                            }
                                        });
                                        _this6.originFilter.add(link.origin);
                                        _this6.events && _this6.events.trigger('danmaku_filter', {
                                            key: 'origin',
                                            value: _toConsumableArray(_this6.originFilter)
                                        });
                                    }
                                };
                                resolve(data);
                            },
                            error: function error(_error) {
                                var currentOrigin = _this6.player.template['danmakuSource_'.concat(link.origin)];
                                var originOperate = currentOrigin.querySelector('.mfunsPlayer-video-danmaku-source-item-operate');
                                currentOrigin.classList.replace('nodata', 'error');
                                originOperate.addEventListener('click', function () {
                                    _this6.reloadEndPoints(link.origin);
                                });
                                reject(_error);
                            }
                        });
                    });
                });
                Promise.all(_toConsumableArray(allRequests)).then(function (res) {
                    callback(res, 1);
                })['catch'](function (err) {
                    console.log(err);
                    callback(err, 0, origin);
                });
            }
        },
        {
            key: 'send',
            value: function send(dan) {
                var _dan$type, _dan$color, _dan$size;
                var newDanmakuId = this.createHash(8);
                var danmakuData = {
                    time: this.options.time() + 0.2,
                    size: dan.size || 25,
                    author: this.player.options.uid,
                    id: newDanmakuId,
                    text: dan.text,
                    color: dan.color || 16777215,
                    type: dan.type || 'right'
                };
                var danmaku = {
                    text: this.htmlEncode(danmakuData.text),
                    color: danmakuData.color,
                    size: danmakuData.size,
                    type: danmakuData.type,
                    id: newDanmakuId,
                    isSubtitle: /(\/n)|(\\n)/i.test(danmakuData.text),
                    border: '2px solid '.concat(this.options.borderColor)
                };
                console.log(danmakuData);
                this.dan.splice(this.danIndex, 0, danmakuData);
                this.danIndex++;
                this.draw(danmaku);
                this.options.sendDanmaku && this.options.sendDanmaku([
                    +this.options.time().toFixed(2),
                    utils.type2Number((_dan$type = dan.type) !== null && _dan$type !== void 0 ? _dan$type : 'right'),
                    utils.color2Number((_dan$color = dan.color) !== null && _dan$color !== void 0 ? _dan$color : '#FFFFFF'),
                    dan.text,
                    (_dan$size = +dan.size) !== null && _dan$size !== void 0 ? _dan$size : 25
                ], this.options.videoIndex());
                this.events && this.events.trigger('danmaku_send', danmakuData);
            }
        },
        {
            key: 'getDanmakuData',
            value: function getDanmakuData(id) {
                var dan;
                for (var i = 0; i < this.dan.length; i++) {
                    if (this.dan[i].id === id) {
                        dan = this.dan[i];
                        break;
                    }
                }
                return dan;
            }
        },
        {
            key: 'frame',
            value: function frame() {
                var _this7 = this;
                if (this.dan.length && !this.paused && this.showing) {
                    var item = this.dan[this.danIndex];
                    var dan = [];
                    while (item && this.options.time() > parseFloat(item.time)) {
                        if (this.checkShield(item)) {
                            dan.push(item);
                        }
                        item = this.dan[++this.danIndex];
                    }
                    if (this.colorLimit) {
                        this.draw(dan.filter(function (el) {
                            return el.color === 16777215;
                        }));
                    } else {
                        this.draw(dan);
                    }
                }
                window.requestAnimationFrame(function () {
                    _this7.frame();
                });
            }
        },
        {
            key: 'limitArea',
            value: function limitArea(areaType) {
                if (areaType === 'keepOutSubtitle') {
                    this.keepOutSubtitle = true;
                    this.container.style.bottom = '20%';
                    return;
                } else if (areaType === 'notKeepOutSubtitle') {
                    this.keepOutSubtitle = false;
                    this.container.style.bottom = '0';
                    return;
                }
                this._limitArea = Math.min(areaType / 4, 1);
                this.shield('bottom', areaType < 4);
                this.unlimited = areaType > 4;
                this.events && this.events.trigger('setDanmaku', {
                    key: 'limitArea',
                    value: areaType
                });
            }
        },
        {
            key: 'shield',
            value: function shield(type) {
                var _this8 = this;
                var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                console.log(type, flag);
                this[''.concat(type, 'Limit')] = flag;
                if (flag) {
                    this.clear(type);
                    var forbidDanmaku = this.container.querySelectorAll('.mfunsPlayer-danmaku-'.concat(type));
                    forbidDanmaku.forEach(function (el) {
                        if (!el.classList.contains('subtitle')) {
                            el.innerHTML = '';
                        }
                    });
                }
                if (type === 'color') {
                    var items = this.container.querySelectorAll('.mfunsPlayer-danmaku-item');
                    items.forEach(function (el) {
                        if (el.style.color !== 'rgb(255, 255, 255)' && !el.classList.contains('subtitle')) {
                            el.innerHTML = '';
                        }
                    });
                }
                if (type === 'special') {
                }
                var filterArr = [];
                var allType = [
                    'top',
                    'bottom',
                    'left',
                    'right',
                    'color',
                    'special'
                ];
                allType.forEach(function (el) {
                    if (_this8[''.concat(el, 'Limit')]) {
                        filterArr.push(el);
                    }
                });
                this.events && this.events.trigger('setDanmaku', {
                    key: 'shields',
                    value: filterArr
                });
                this.events && this.events.trigger('danmaku_filter', {
                    key: 'type',
                    value: filterArr
                });
            }
        },
        {
            key: 'opacity',
            value: function opacity(percentage) {
                if (percentage !== undefined) {
                    var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-item');
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].classList.contains('subtitle'))
                            continue;
                        items[i].style.opacity = percentage;
                    }
                    this._opacity = percentage;
                    this.events && this.events.trigger('setDanmaku', {
                        key: 'opacity',
                        value: percentage
                    });
                }
                return this._opacity;
            }
        },
        {
            key: 'size',
            value: function size(scale) {
                this._fontScale = scale;
                this.events && this.events.trigger('setDanmaku', {
                    key: 'fontScale',
                    value: Number(scale.toFixed(2))
                });
                return this._fontScale;
            }
        },
        {
            key: 'speed',
            value: function speed(_speed) {
                var speedName;
                if (_speed !== undefined) {
                    switch (_speed) {
                    case 0.5:
                        speedName = 'lowest';
                        break;
                    case 0.75:
                        speedName = 'low';
                        break;
                    case 1:
                        speedName = '';
                        break;
                    case 1.25:
                        speedName = 'fast';
                        break;
                    case 1.5:
                        speedName = 'fastest';
                        break;
                    default:
                        break;
                    }
                    var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-move');
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].classList.contains('subtitle'))
                            continue;
                        if (!!speedName) {
                            items[i].classList.add(speedName);
                        }
                        if (!!this._speed) {
                            items[i].classList.remove(this._speed);
                        }
                    }
                }
                this._speed = speedName;
                this._speedVal = _speed;
                this.events && this.events.trigger('setDanmaku', {
                    key: 'speed',
                    value: _speed
                });
            }
        },
        {
            key: 'draw',
            value: function draw(dan) {
                var _this9 = this;
                if (this.showing) {
                    var itemHeight = this.options.height * this._fontScale;
                    var danWidth = this.container.offsetWidth;
                    var danHeight = this.container.offsetHeight * this._limitArea;
                    var itemY = Math.floor(danHeight / itemHeight);
                    if (this.tunnelHeights.right.length !== itemY)
                        this.tunnelHeights.right = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.left.length !== itemY)
                        this.tunnelHeights.left = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.top.length !== itemY)
                        this.tunnelHeights.top = utils.createArray(itemY, itemHeight);
                    if (this.tunnelHeights.bottom.length !== itemY)
                        this.tunnelHeights.bottom = utils.createArray(itemY, itemHeight);
                    var danItemRight = function danItemRight(ele, istest) {
                        var eleWidth = ele.offsetWidth || parseInt(ele.style.width);
                        var eleRight = ele.getBoundingClientRect().right || _this9.container.getBoundingClientRect().right + eleWidth;
                        if (istest) {
                            console.dir(ele.offsetWidth);
                        }
                        return _this9.container.getBoundingClientRect().right - eleRight;
                    };
                    var danItemLeft = function danItemLeft(ele) {
                        var eleWidth = ele.clientWidth || parseInt(ele.style.width);
                        var eleLeft = ele.getBoundingClientRect().left || _this9.container.getBoundingClientRect().left + eleWidth;
                        return _this9.container.getBoundingClientRect().left - eleLeft;
                    };
                    var danSpeed = function danSpeed(width) {
                        var _this9$_speedVal;
                        return ((danWidth + width) / _this9.player.fullScreen.isFullScreen() ? 8 : 5) * ((_this9$_speedVal = _this9._speedVal) !== null && _this9$_speedVal !== void 0 ? _this9$_speedVal : 1);
                    };
                    var realDOMTunnel = function realDOMTunnel(type, i) {
                        return _toConsumableArray(_this9.container.querySelectorAll('.mfunsPlayer-danmaku-'.concat(type))).filter(function (el) {
                            return el.dataset.tunnel === ''.concat(i);
                        });
                    };
                    var getTunnel = function getTunnel(ele, type, width) {
                        var tmp = danWidth / danSpeed(width);
                        var _loop = function _loop(i) {
                            var DOMTunnel = realDOMTunnel(type, i);
                            var item = _this9.danTunnel[type][i + ''];
                            _this9.danTunnel[type][i + ''] = DOMTunnel;
                            if (itemY < i)
                                console.log('-------', i);
                            if (item && item.length) {
                                if (type !== 'right' && type !== 'left') {
                                    return 'continue';
                                }
                                if (item.length !== DOMTunnel.length) {
                                    item = DOMTunnel;
                                }
                                for (var j = 0; j < item.length; j++) {
                                    if (type === 'right') {
                                        var danRight = danItemRight(item[j]) - 10;
                                        if (danRight <= 0) {
                                            _this9.tunnelHeights[type][i] = parseInt(_this9.miniMode ? 16 : item[j].style.fontSize) + _this9.tunnelPadding;
                                            break;
                                        }
                                    }
                                    if (type === 'left') {
                                        var danLeft = danItemLeft(item[j]) - 10;
                                        _this9.tunnelHeights[type][i] = parseInt(item[j].style.fontSize) + _this9.tunnelPadding;
                                        if (danLeft <= danWidth - tmp * danSpeed(parseInt(item[j].style.width)) || danLeft <= 0) {
                                            break;
                                        }
                                    }
                                    if (j === item.length - 1) {
                                        _this9.tunnelHeights[type][i] = parseInt(_this9.miniMode ? 16 : item[j].style.fontSize) + _this9.tunnelPadding;
                                        _this9.danTunnel[type][i + ''].push(ele);
                                        ele.addEventListener('animationend', function () {
                                            var _this9$danTunnel$type, _this9$danTunnel$type2;
                                            var index = (_this9$danTunnel$type = _this9.danTunnel[type][i + '']) === null || _this9$danTunnel$type === void 0 ? void 0 : _this9$danTunnel$type.indexOf(ele);
                                            _this9.danTunnel[type] !== {} && ((_this9$danTunnel$type2 = _this9.danTunnel[type][i + '']) === null || _this9$danTunnel$type2 === void 0 ? void 0 : _this9$danTunnel$type2.splice(index, 1));
                                        });
                                        return { v: i };
                                    }
                                }
                            } else {
                                if (Array.isArray(_this9.danTunnel[type][i + ''])) {
                                    _this9.danTunnel[type][i + ''].push(ele);
                                } else {
                                    _this9.danTunnel[type][i + ''] = [ele];
                                }
                                ele.addEventListener('animationend', function () {
                                    var _this9$danTunnel$type3, _this9$danTunnel$type4;
                                    var index = (_this9$danTunnel$type3 = _this9.danTunnel[type][i + '']) === null || _this9$danTunnel$type3 === void 0 ? void 0 : _this9$danTunnel$type3.indexOf(ele);
                                    _this9.danTunnel[type] !== {} && ((_this9$danTunnel$type4 = _this9.danTunnel[type][i + '']) === null || _this9$danTunnel$type4 === void 0 ? void 0 : _this9$danTunnel$type4.splice(index, 1));
                                });
                                return { v: i };
                            }
                        };
                        for (var i = 0; _this9.unlimited || i < itemY; i++) {
                            var _ret = _loop(i);
                            if (_ret === 'continue')
                                continue;
                            if (_typeof(_ret) === 'object')
                                return _ret.v;
                        }
                        return -1;
                    };
                    if (Object.prototype.toString.call(dan) !== '[object Array]') {
                        dan = [dan];
                    }
                    var docFragment = document.createDocumentFragment();
                    var _loop2 = function _loop2(i) {
                        var _dan$i$size;
                        if (dan[i].type >= 7) {
                            return 'continue';
                        }
                        if (!dan[i].color) {
                            dan[i].color = 16777215;
                        }
                        if (!dan[i].size) {
                            dan[i].size = 25;
                        }
                        var item = document.createElement('div');
                        if (!_this9.paused) {
                            item.classList.add('mfunsPlayer-danmaku-run');
                        } else {
                            item.classList.remove('mfunsPlayer-danmaku-run');
                        }
                        item.classList.add('mfunsPlayer-danmaku-item');
                        item.classList.add('mfunsPlayer-danmaku-'.concat(dan[i].type));
                        dan[i].isSubtitle = /(\/n)|(\\n)/i.test(dan[i].text);
                        dan[i].isSubtitle && item.classList.add('subtitle');
                        if (dan[i].border) {
                            item.innerHTML = '<span style="border:'.concat(dan[i].border, '">').concat(dan[i].text.replace(/(\/n)|(\\n)/g, '\n'), '</span>');
                        } else {
                            item.innerHTML = '<span>'.concat(dan[i].text.replace(/(\/n)|(\\n)/g, '\n'), '</span>');
                        }
                        if (typeof dan[i].color !== 'string') {
                            item.style.color = utils.number2Color(dan[i].color);
                        }
                        item.style.opacity = _this9._opacity;
                        item.style.fontSize = +dan[i].size * (dan[i].isSubtitle ? 1 : _this9._fontScale) + 'px';
                        item.addEventListener('animationend', function () {
                            if (_toConsumableArray(_this9.container.children).indexOf(item) > -1)
                                _this9.container.removeChild(item);
                        });
                        var itemWidth = _this9._measure(dan[i].text, (_dan$i$size = +dan[i].size) !== null && _dan$i$size !== void 0 ? _dan$i$size : 25);
                        var tunnel = void 0;
                        var realTunnel = void 0;
                        switch (dan[i].type) {
                        case 'right':
                            realTunnel = getTunnel(item, dan[i].type, itemWidth);
                            tunnel = realTunnel % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var maxTop = _this9.tunnelHeights.right.slice(0, itemY).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                var top = _this9.tunnelHeights.right.slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0) % maxTop;
                                if (top + parseInt(item.style.fontSize) + _this9.tunnelPadding > danHeight) {
                                    var _this9$danTunnel$dan$;
                                    (_this9$danTunnel$dan$ = _this9.danTunnel[dan[i].type][i + '']) === null || _this9$danTunnel$dan$ === void 0 ? void 0 : _this9$danTunnel$dan$.pop();
                                    return { v: void 0 };
                                }
                                item.dataset.tunnel = realTunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.top = (dan[i].isSubtitle ? 0 : top) + 'px';
                                item.style.transform = 'translateX(-'.concat(danWidth, 'px)');
                            }
                            break;
                        case 'left':
                            if (_this9.miniMode)
                                return { v: void 0 };
                            realTunnel = getTunnel(item, dan[i].type, itemWidth);
                            tunnel = realTunnel % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var _maxTop = _this9.tunnelHeights.left.slice(0, itemY).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                var _top = _this9.tunnelHeights.left.slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0) % _maxTop;
                                if (_top + parseInt(item.style.fontSize) + _this9.tunnelPadding > danHeight) {
                                    var _this9$danTunnel$dan$2;
                                    (_this9$danTunnel$dan$2 = _this9.danTunnel[dan[i].type][i + '']) === null || _this9$danTunnel$dan$2 === void 0 ? void 0 : _this9$danTunnel$dan$2.pop();
                                    return { v: void 0 };
                                }
                                item.dataset.tunnel = realTunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.top = (dan[i].isSubtitle ? 0 : _top) + 'px';
                                item.style.transform = 'translateX('.concat(danWidth, 'px)');
                            }
                            break;
                        case 'top':
                            if (_this9.miniMode)
                                return { v: void 0 };
                            tunnel = getTunnel(item, dan[i].type) % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var topArr = [];
                                var topDan = _this9.danTunnel.top;
                                for (var key in topDan) {
                                    topArr.push.apply(topArr, _toConsumableArray(topDan[key]));
                                }
                                var _top2 = topArr.map(function (el) {
                                    return parseInt(el.style.fontSize) + _this9.tunnelPadding;
                                }).slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                if (_top2 + parseInt(item.style.fontSize) + _this9.tunnelPadding > danHeight) {
                                    var _this9$danTunnel$dan$3;
                                    (_this9$danTunnel$dan$3 = _this9.danTunnel[dan[i].type][i + '']) === null || _this9$danTunnel$dan$3 === void 0 ? void 0 : _this9$danTunnel$dan$3.pop();
                                    return { v: void 0 };
                                }
                                item.dataset.tunnel = tunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.marginLeft = '-'.concat((itemWidth + 1) * 0.5, 'px');
                                item.style.top = (dan[i].isSubtitle ? 0 : _top2) + 'px';
                            }
                            break;
                        case 'bottom':
                            if (_this9.miniMode)
                                return { v: void 0 };
                            tunnel = getTunnel(item, dan[i].type) % itemY;
                            if (tunnel >= 0 || dan[i].isSubtitle) {
                                var bottomArr = [];
                                var bottomDan = _this9.danTunnel.bottom;
                                for (var _key in bottomDan) {
                                    bottomArr.push.apply(bottomArr, _toConsumableArray(bottomDan[_key]));
                                }
                                var bottom = bottomArr.map(function (el) {
                                    return parseInt(el.style.fontSize) + _this9.tunnelPadding;
                                }).slice(0, tunnel).reduce(function (prev, cur) {
                                    return prev + cur;
                                }, 0);
                                if (bottom + parseInt(item.style.fontSize) + _this9.tunnelPadding > danHeight) {
                                    var _this9$danTunnel$dan$4;
                                    (_this9$danTunnel$dan$4 = _this9.danTunnel[dan[i].type][i + '']) === null || _this9$danTunnel$dan$4 === void 0 ? void 0 : _this9$danTunnel$dan$4.pop();
                                    return { v: void 0 };
                                }
                                item.dataset.tunnel = tunnel;
                                item.dataset.origin = dan[i].origin;
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.marginLeft = '-'.concat((itemWidth + 1) * 0.5, 'px');
                                item.style.bottom = (dan[i].isSubtitle ? 0 : bottom) + 'px';
                            }
                            break;
                        default:
                            console.error('无法处理的弹幕模式: '.concat(dan[i].type));
                        }
                        if (tunnel >= 0) {
                            item.classList.add('mfunsPlayer-danmaku-move');
                            item.dataset.id = dan[i].id;
                            if (!!_this9._speed && !dan[i].isSubtitle) {
                                item.classList.add(_this9._speed);
                            }
                            _this9.container.appendChild(item);
                        }
                    };
                    for (var i = 0; i < dan.length; i++) {
                        var _ret2 = _loop2(i);
                        if (_ret2 === 'continue')
                            continue;
                        if (_typeof(_ret2) === 'object')
                            return _ret2.v;
                    }
                    return docFragment;
                }
            }
        },
        {
            key: 'removeDanmakuCheck',
            value: function removeDanmakuCheck() {
                this.lockDanmaku && this.lockDanmaku.classList.remove('lock');
                this.player.template.danmakuTip.classList.remove('show');
                this.lockDanmaku.dataset.moved = 0;
                this.lockDanmaku.style.zIndex = 'auto';
                this.container.style.cursor = 'none';
            }
        },
        {
            key: 'play',
            value: function play() {
                this.paused = false;
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
            }
        },
        {
            key: '_measure',
            value: function _measure(text, size) {
                var _measureStyle$getProp;
                if (!this.demoDanmaku) {
                    this.demoDanmaku = this.container.getElementsByClassName('mfunsPlayer-danmaku-item')[0];
                }
                this.demoDanmaku.style.fontSize = (this.miniMode ? 16 : size) * this._fontScale + 'px';
                var measureStyle = getComputedStyle(this.demoDanmaku, false);
                if (!this.context) {
                    this.context = document.createElement('canvas').getContext('2d');
                }
                var fontSize = measureStyle.getPropertyValue('font-size');
                var fontWeight = measureStyle.getPropertyValue('font-weight');
                var fontFamily = measureStyle.getPropertyValue('font-family');
                this.context.font = (_measureStyle$getProp = measureStyle.getPropertyValue('font')) !== null && _measureStyle$getProp !== void 0 ? _measureStyle$getProp : ''.concat(fontWeight, '  ').concat(fontSize, ' / ').concat(fontSize, ' ').concat(fontFamily);
                return this.context.measureText(text).width;
            }
        },
        {
            key: 'seek',
            value: function seek() {
                this.clear();
                for (var i = 0; i < this.dan.length; i++) {
                    if (this.dan[i].time >= this.options.time()) {
                        this.danIndex = i;
                        break;
                    }
                    this.danIndex = this.dan.length;
                }
            }
        },
        {
            key: 'clear',
            value: function clear(type) {
                console.log('clear');
                if (type) {
                    this.danTunnel[type] = {};
                    return;
                }
                this.danTunnel = {
                    left: {},
                    right: {},
                    top: {},
                    bottom: {}
                };
                this.danIndex = 0;
                this.options.container.innerHTML = '';
                this.options.container.appendChild(this.demoDanmaku);
                this.events && this.events.trigger('danmaku_clear');
            }
        },
        {
            key: 'htmlEncode',
            value: function htmlEncode(str) {
                return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;');
            }
        },
        {
            key: 'resize',
            value: function resize() {
                var danWidth = this.container.offsetWidth;
                var items = this.container.getElementsByClassName('mfunsPlayer-danmaku-right');
                for (var i = 0; i < items.length; i++) {
                    items[i].style.transform = 'translateX(-'.concat(danWidth, 'px)');
                }
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.showing = false;
                this.pause();
                this.clear();
                this.events && this.events.trigger('danmaku_hide');
                this.events && this.events.trigger('setDanmaku', {
                    key: 'show',
                    value: false
                });
            }
        },
        {
            key: 'show',
            value: function show() {
                this.seek();
                this.showing = true;
                this.play();
                this.events && this.events.trigger('danmaku_show');
                this.events && this.events.trigger('setDanmaku', {
                    key: 'show',
                    value: true
                });
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.showing) {
                    this.hide();
                } else {
                    this.show();
                }
            }
        },
        {
            key: 'unlimit',
            value: function unlimit(_boolean) {
                this.unlimited = _boolean;
            }
        },
        {
            key: 'mini',
            value: function mini(flag) {
                this.miniMode = flag;
                this.options.height = flag ? 22 : 28;
            }
        }
    ]);
    return Danmaku;
}();
export default Danmaku;